import { useProperty } from '@eti/providers';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { isCarrierCodesPresentInSomeSegments } from '../../../common/utils/carriersUtils';
const useSortedBaggageOptions = (bounds, options) => {
  const {
    p
  } = useProperty();
  const isAlternativeDisplayOrderEnabled = p('TravelerDetails.Product.Baggages.Options.Alternative.DisplayOrder.Enabled');
  const excludedCarriers = p('TravelerDetails.Product.Baggages.Options.Alternative.DisplayOrder.ExcludedCarriers') || [];
  const shouldUseAlternativeOrder = isAlternativeDisplayOrderEnabled && !isCarrierCodesPresentInSomeSegments(excludedCarriers, bounds);
  if (!shouldUseAlternativeOrder) {
    return options;
  }
  const [noOption, ...paidOptions] = options;
  return [...paidOptions, noOption];
};
export default useSortedBaggageOptions;
//# sourceMappingURL=useSortedBaggageOptions.js.map